var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.884,
    height: 16.437,
    viewBox: "0 0 9.884 16.437",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__Union_4",
    fill: "none",
    stroke: "#4e4e57",
    strokeWidth: "2px",
    d: "M7.75 7.5L0 15l7.75-7.5.25.242-.25-.242.25-.242-.25.242L0 0z",
    "data-name": "Union 4",
    transform: "translate(.695 .719)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlack);
export default __webpack_public_path__ + "static/media/arrow-black.40d35f4c5b656d27ed39c8727c75ddbc.svg";
export { ForwardRef as ReactComponent };